var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.customConfig.packages && _vm.customConfig.packages != "4"
    ? _c("div", { staticClass: "dashboard-container" }, [
        _c("div", { staticClass: "core-data-row" }, [
          _c("div", { staticClass: "data-card" }, [
            _c("div", { staticClass: "card-content" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "card-info" }, [
                _c("div", { staticClass: "card-title" }, [_vm._v("总销售额")]),
                _vm._v(" "),
                _c("div", { staticClass: "card-value" }, [
                  _vm._v(
                    "¥" +
                      _vm._s(_vm.formatMoney(_vm.overviewData.totalSales || 0))
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "data-card" }, [
            _c("div", { staticClass: "card-content" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "card-info" }, [
                _c("div", { staticClass: "card-title" }, [_vm._v("总订单数")]),
                _vm._v(" "),
                _c("div", { staticClass: "card-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatNumber(_vm.overviewData.totalOrderCount || 0)
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "data-card" }, [
            _c("div", { staticClass: "card-content" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "card-info" }, [
                _c("div", { staticClass: "card-title" }, [_vm._v("总用户数")]),
                _vm._v(" "),
                _c("div", { staticClass: "card-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatNumber(_vm.overviewData.totalUserCount || 0)
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "data-card" }, [
            _c("div", { staticClass: "card-content" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "card-info" }, [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v("总支付用户数"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatNumber(_vm.overviewData.totalPayUserCount || 0)
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "data-card" }, [
            _c("div", { staticClass: "card-content" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "card-info" }, [
                _c("div", { staticClass: "card-title" }, [_vm._v("总浏览量")]),
                _vm._v(" "),
                _c("div", { staticClass: "card-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatNumber(_vm.overviewData.totalPageviews || 0)
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "trend-rank-panel" }, [
          _c("div", { staticClass: "panel-header" }, [
            _c(
              "div",
              { staticClass: "panel-header-extra" },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "small" },
                    on: { change: _vm.handleTimeRangeChange },
                    model: {
                      value: _vm.timeRange,
                      callback: function ($$v) {
                        _vm.timeRange = $$v
                      },
                      expression: "timeRange",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "today" } }, [
                      _vm._v("今天"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "recent7" } }, [
                      _vm._v("近7天"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "recent30" } }, [
                      _vm._v("近30天"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "week" } }, [
                      _vm._v("本周"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "month" } }, [
                      _vm._v("本月"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "quarter" } }, [
                      _vm._v("本季度"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "year" } }, [
                      _vm._v("本年"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "all" } }, [
                      _vm._v("全部"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "panel-trend" }, [
              _c("div", { staticClass: "panel-section-title-row" }, [
                _c(
                  "div",
                  { staticClass: "core-col-title panel-section-title" },
                  [_vm._v("销售趋势图")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "panel-trend-summary" }, [
                  _c("span", { staticClass: "trend-summary-item" }, [
                    _vm._v("\n              订单总金额\n              "),
                    _c("em", [
                      _vm._v(
                        "¥" +
                          _vm._s(_vm.formatMoney(_vm.coreData.todaySales || 0))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "trend-summary-item" }, [
                    _vm._v("\n              订单数\n              "),
                    _c("em", [
                      _vm._v(
                        _vm._s(
                          _vm.formatNumber(_vm.coreData.todayOrderCount || 0)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "trend-summary-item" }, [
                    _vm._v("\n              支付用户数\n              "),
                    _c("em", [
                      _vm._v(
                        _vm._s(
                          _vm.formatNumber(_vm.coreData.todayPayUserCount || 0)
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-col-content panel-trend-chart" },
                [
                  _c("visit-chart", {
                    ref: "visitChart",
                    attrs: { value: _vm.timeRange },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "panel-rank" }, [
              _c("div", { staticClass: "core-col-title panel-section-title" }, [
                _vm._v("商品销售排行榜"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.trendProductRankLoading,
                      expression: "trendProductRankLoading",
                    },
                  ],
                  staticClass: "panel-col-content rank-list-wrap",
                },
                [
                  _c(
                    "ul",
                    { staticClass: "rank-list" },
                    _vm._l(_vm.displayRankList, function (row, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "rank-item",
                          class: { "is-placeholder": row.isPlaceholder },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "rank-badge",
                              class: {
                                "is-top": !row.isPlaceholder && index < 3,
                              },
                            },
                            [_vm._v(_vm._s(index + 1))]
                          ),
                          _vm._v(" "),
                          row.isPlaceholder
                            ? [
                                _vm._m(5, true),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "rank-placeholder-text" },
                                  [_vm._v("暂无数据")]
                                ),
                              ]
                            : [
                                _c(
                                  "span",
                                  {
                                    staticClass: "rank-name",
                                    attrs: { title: row.productName },
                                  },
                                  [_vm._v(_vm._s(row.productName))]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "rank-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.formatRankValue(row.salesAmount))
                                  ),
                                ]),
                              ],
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "core-analysis-panel" }, [
          _c("div", { staticClass: "core-analysis-card" }, [
            _c("div", { staticClass: "core-col-title" }, [
              _vm._v("用户增长趋势"),
            ]),
            _vm._v(" "),
            _c("div", { ref: "userChart", staticClass: "core-col-chart" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "core-analysis-card" }, [
            _c("div", { staticClass: "core-col-title" }, [
              _vm._v("销售地区分布"),
            ]),
            _vm._v(" "),
            _c("div", { ref: "regionChart", staticClass: "core-col-chart" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "core-analysis-card" }, [
            _c("div", { staticClass: "core-col-title" }, [
              _vm._v("销售分类分布"),
            ]),
            _vm._v(" "),
            _c("div", { ref: "categoryChart", staticClass: "core-col-chart" }),
          ]),
        ]),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { staticClass: "loading-mask" }, [_vm._m(6)])
          : _vm._e(),
      ])
    : _vm.customConfig.packages && _vm.customConfig.packages == "4"
    ? _c("div", [_c("list")], 1)
    : _c("div", [_vm._v("欢迎您！")])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-icon sales-icon" }, [
      _c("i", { staticClass: "el-icon-coin" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-icon order-icon" }, [
      _c("i", { staticClass: "el-icon-s-order" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-icon user-icon" }, [
      _c("i", { staticClass: "el-icon-user-solid" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-icon pay-user-icon" }, [
      _c("i", { staticClass: "el-icon-s-custom" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-icon pageview-icon" }, [
      _c("i", { staticClass: "el-icon-view" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "rank-skel-name-wrap" }, [
      _c("span", { staticClass: "rank-skel rank-skel-name" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-content" }, [
      _c("i", {
        staticClass: "el-icon-loading",
        staticStyle: { "font-size": "40px", color: "#409EFF" },
      }),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-top": "10px" } }, [
        _vm._v("数据加载中..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }